module.exports = __webpack_public_path__ + "img/product-30.118468cb.jpg";